import request from '@/router/axios';
const hrcloudUrlPrefix = '/sys'

/**queryUserListPage
 *  阅读加一接口
 */
export function addNewReadCount(id) {
  return request({
  	url: hrcloudUrlPrefix+'/home/addNewReadCount/'+id,
  	method: 'post'
  });
}

/**
 *  点赞接口
 */
export function addNewThumb(id) {
  return request({
  	url: hrcloudUrlPrefix+'/home/addNewThumb/'+id,
  	method: 'post'
  });
}

/**
 *  系统操作手册数据列表
 */
export function queryNewsById(id) {
  return request({
  	url: hrcloudUrlPrefix+'/home/queryNewsById/'+id,
  	method: 'get'
  });
}


/**
 *  系统操作手册数据列表
 */
export function queryOperManual() {
  return request({
  	url: hrcloudUrlPrefix+'/home/queryOperManual',
  	method: 'get'
  });
}
/**
 *  系统操作手册详情
 */
export function queryOperManualById(id) {
  return request({
    url: hrcloudUrlPrefix+'/home/queryOperManualById/'+id,
    method: 'get'
  });
}

/**
 *  快捷入口数据列表
 */
export function queryQuickEntryList(type) {
  return request({
  	url: hrcloudUrlPrefix+'/home/queryQuickEntryList/'+type,
  	method: 'get'
  });
}

/**
 *  保存自定义快捷入口
 */
export function addQuickEntryR(obj) {
  return request({
  	url: hrcloudUrlPrefix+'/home/addQuickEntryR',
  	method: 'POST',
  	data:obj
  });
}

/**
 *  日历中查询某个日期下的消息列表
 */
export function queryTodoMsg(date) {
  return request({
  	url: hrcloudUrlPrefix+'/home/queryTodoMsg/'+date,
  	method: 'get'
  });
}

/**
 *  日历中查询某个日期下的消息列表
 */
export function updateTodoStatus(obj) {
  return request({
  	url: hrcloudUrlPrefix+'/home/updateTodoStatus',
  	method: 'POST',
  	data:obj
  });
}


/**
 *  添加待办事项
 */
export function addTodo(obj) {
  return request({
  	url: hrcloudUrlPrefix+'/home/addTodo',
  	method: 'POST',
  	data:obj
  });
}

/**
 *  获取服务器时间及日历月份数据加载
 */
export function queryCalendarData(obj) {
  return request({
  	url: hrcloudUrlPrefix+'/home/queryCalendarData',
  	method: 'get',
		params: obj
  });
}


/**
 *  资讯
 */
export function queryNewsList(type,obj) {
  return request({
  	url: hrcloudUrlPrefix+'/home/queryNewsList/'+type,
  	method: 'POST',
		data:obj
  });
}

/**
 *  人事概况接口
 */
export function queryPersonnel() {
  return request({
  	url: hrcloudUrlPrefix+'/home/queryPersonnel',
  	method: 'get'
  });
}

/**
 *  首页人事待处理
 */
export function queryPendingList() {
  return request({
    url: hrcloudUrlPrefix+'/home/queryPendingList',
    method: 'get'
  });
}
/**
 *  人事待处理数值查询
 */
export function queryPendingNum(type) {
  return request({
    url:  hrcloudUrlPrefix+'/home/queryPendingNum/'+type,
    method: 'get',
  });
}






/**
 * 分页查询用户下的站内消息
 * @param query
 */
export function queryUserListPage(obj) {
  return request({
    url: '/message/message-log/page/my',
    method: 'get',
    params: obj
  });
}

/**
 * 根据类型分页查询用户下的站内消息
 * @param query
 */
export function queryListPageByType(obj) {
  return request({
    url: '/message/message-log/page/type',
    method: 'post',
    data: obj
  });
}

/**
 * 根据id批量修改站内消息状态
 * @param query
 */
export function updateBatchMsgStatus(obj) {
  return request({
    url: '/message/message-log/update/batch',
    method: 'put',
    data: obj
  });
}

/**
 * 根据id 批量删除站内消息
 * @param query
 */
export function deletBatchMsg(obj) {
  return request({
    url: '/message/message-log/delete/batch',
    method: 'delete',
    data: obj
  });
}
/**
 *  加载消息未读数量
 */
export function getUnReadMsgNum(type) {
  return request({
    url:  hrcloudUrlPrefix+'/home/queryUnReadMsgNum/'+type,
    method: 'get',
  });
}
export function queryMsgList(obj) {
  return request({
    url:  hrcloudUrlPrefix+'/home/queryMsgList/'+obj.type,
    method: 'post',
    data: obj
  });
}
export function updateBatchHrcloudMsgStatus(obj) {
  return request({
    url:  hrcloudUrlPrefix+'/home/updateMsgInfo/',
    method: 'post',
    data: obj
  });
}

/**
 *  最新资讯列表
 */
export function getToWxGzh(obj) {
  return request({
    url:    'sys/wc/getToWxGzh',
    method: 'get',
    params: obj
  });
}

